/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const QualityCommentsInCodeEditorSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('QUALITY_COMMENTS_IN_CODE_EDITOR')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class QualityCommentsInCodeEditorSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return QualityCommentsInCodeEditorSettingParser.decode(input).map(res => new QualityCommentsInCodeEditorSetting(res));
    }
    static unsafeDecode(input) {
        return QualityCommentsInCodeEditorSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return QualityCommentsInCodeEditorSettingParser.encode(data);
    }
    static schema() {
        return QualityCommentsInCodeEditorSettingParser.schema();
    }
}
